<script>
import { mapGetters } from 'vuex';
import LoadIndicator from './LoadIndicator';
import Project from './Project';

export default {
    name: 'ContentProjectsBlock',
    components: {
        LoadIndicator,
        Project
    },
    props: {
        data: Object,
    },
    data: () => {
        return {
            shownProjects: 5,
            totalProjects: 0,
        }
    },
    mounted() {
        this.$store.dispatch('loadAllProjects');
        this.shownProjects = parseInt(this.data.number_of_items);
    },
    methods: {
        onShowMore() {
            this.shownProjects += parseInt(this.data.number_of_items);
        },
        compare(a, b) {
            a = a.order ? parseInt(a.order) : 0;
            b = b.order ? parseInt(b.order) : 0;
            if (a < b){
                return 1;
            }
            if (a > b){
                return -1;
            }
            return 0;
        }
    },
    computed: {
        ...mapGetters({
            isLoading: 'getProjectsIsLoading',
            projects: 'getAllProjects',
        }),
        filteredProjects() {
            let data = [...this.projects];
            data.sort(this.compare);
            this.totalProjects = data.length;
            return data.slice(0, this.shownProjects);
        },
    }
};
</script>

<template>
    <div class="projects-block">
        <h2 class="projects-block__title" v-if="data.title" v-html="data.title"></h2>
        <div class="projects-block__list">
            <div class="projects-block__list__body">
                <project 
                    v-for="(project, i) in filteredProjects" 
                    v-bind:key="i"
                    v-bind:title="project.title.rendered"
                    v-bind:description="project.description"
                    v-bind:organisation="project.organisation"
                    v-bind:link="project.link" 
                    v-bind:featured="project.featured" />

                <div class="projects-block__list__no-items" 
                    v-if="!isLoading && filteredProjects.length === 0">
                        {{ $t('projectsBlock.noItems') }}
                </div>

                <load-indicator v-if="isLoading" />

            </div>

            <div class="projects-block__list__footer">
                <a  class="projects-block__list__load-more" 
                    v-if="totalProjects > shownProjects && !isLoading" 
                    v-on:click="onShowMore">{{ $t('projectsBlock.loadMore') }}
                </a>
            </div>
            
        </div>

    </div>
</template>

<style lang="scss" scoped>
.projects-block__title {
    margin: 9.6rem 0 4.8rem;
    font-weight: 700;
    font-size: 3.2rem;

    @include breakpoint('sm-down') {
        margin: 7.2rem 0 4.8rem;
    }
}

.projects-block__list__body {
    border-top: 0.1rem solid rgba($color-primary, .15);
    border-bottom: 0.1rem solid rgba($color-primary, .15);
}
.projects-block__list__no-items {
    padding: 3.2rem 0;
    text-align: center;
}
.project:last-child {
    border-bottom: none;
}
.load-indicator {
    padding: 3.2rem 0;
    text-align: center;
}
.projects-block__list__footer {
    padding: 0.8rem 0;
    text-align: center;
}
.projects-block__list__load-more {
    font-size: 1.4rem;
    color: $color-secondary;
    letter-spacing: 0.02857142857em;
    line-height: 1;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;
}
</style>
